import { InventoryService } from "@/services/nextshop/inventory.service"
export default {
  methods: {
    // async creatInventoryNegative(locationId) {
    //   try {
    //     const paramsNegative = {
    //       name: "Kho âm tạo mặc định",
    //       address: '',
    //       description: '',
    //       coAppId: "5e86f1882c185a6b907057c1",
    //       isDefault: false,
    //       typeInventory : "NSH_ITEM_SALE_NEGATIVE",
    //       locationId: locationId
    //     }

    //     const response = await InventoryService.creatInventory(paramsNegative)
    //     return response
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async creatInventoryDefault(locationId) {
      try {
        const paramsDefault = {
          name: 'Kho mặc định',
          address: 'Địa chỉ kho mặc định',
          description: "Một kho mặc định do hệ thống tạo",
          coAppId: "5e86f1882c185a6b907057c1",
          isDefault: true,
          typeInventory : "NSH_ITEM_SALE",
          locationId: locationId
        }

        const response = await InventoryService.creatInventory(paramsDefault)
        // this.creatInventoryNegative(locationId) 
        return response
      } catch (error) {
        console.log(error);
      }
    }
  }
}